const BaseApiState = {
  isLoading: false,
  success: false,
  payload: null,
  error: null,
  errorInput:null
};
export interface createBaseAPi {
  isLoading: boolean,
  success: boolean,
  payload: any,
  error: any,
  errorInput:any,
}


export default BaseApiState;


